import React from "react";
import { BrowserRouter as Router } from "react-router-dom"
import Routes from "./components/Routes";
import { ScheduleConfigProvider } from "./components/Schedule/scheduleConfig";

function App() {
  return <Router>
    <ScheduleConfigProvider>
      <Routes />
    </ScheduleConfigProvider>
  </Router>
}

export default App;
